import React from 'react';

const SocioDetailModal = ({ socio, onClose }) => {
  if (!socio) return null;

  const modalOverlayStyle = "fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 transition-opacity duration-300";
  const modalContentStyle = "bg-white border-l-4 border-[#0488AF] rounded-xl shadow-2xl p-0 w-full max-w-2xl max-h-[90vh] overflow-y-auto relative";
  const closeButtonStyle = "absolute top-3 right-3 text-white hover:text-[#C42251] text-3xl font-bold cursor-pointer";
  const detailItemStyle = "flex items-start mb-4 last:mb-0";
  const iconContainerStyle = "bg-[#0488AF]/10 p-2 rounded-lg mr-3 mt-1 flex-shrink-0";
  const iconStyle = "w-5 h-5 text-[#0488AF]";
  const textStyle = "text-gray-800 break-words";
  const labelStyle = "text-gray-900 font-semibold block mb-1";

  return (
    <div className={modalOverlayStyle} onClick={onClose}>
      <div className={modalContentStyle} onClick={(e) => e.stopPropagation()}>
        <div className="w-full bg-gradient-to-br from-[#09274A] to-[#0488AF] rounded-t-xl p-5 shadow-sm">
          <span className={closeButtonStyle} onClick={onClose} aria-label="Cerrar">&times;</span>
          
          <div className="flex flex-col sm:flex-row items-center">
            {socio.logo && (
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-white flex items-center justify-center overflow-hidden mr-0 sm:mr-5 mb-4 sm:mb-0 flex-shrink-0 shadow-sm border border-white/30">
                <img
                  src={socio.logo}
                  alt={`Logo de ${socio.business_name}`}
                  className="w-full h-full object-contain p-1"
                  onError={(e) => { 
                    e.target.onerror = null; 
                    e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(socio.business_name || 'L')}&background=0488AF&color=fff&size=96`;
                  }}
                />
              </div>
            )}
            <div className="min-w-0 text-center sm:text-left">
              <h2 className="text-2xl lg:text-3xl font-bold text-white">
                {socio.trade_name || 'Nombre no disponible'}
              </h2>
              {socio.industry && (
                <span className="inline-block mt-2 px-3 py-1 text-sm font-semibold bg-[#DC3465] text-white rounded-full shadow-sm">
                  {socio.industry}
                </span>
              )}
            </div>
          </div>
        </div>
        
        <div className="p-6 bg-white">
          <div className="space-y-4">
            {socio.trade_name && (
              <div className={detailItemStyle}>
                <div className={iconContainerStyle}>
                  <svg className={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <span className={labelStyle}>Razón Social:</span>
                  <span className={textStyle}>{socio.business_name}</span>
                </div>
              </div>
            )}

            {socio.contact_email && (
              <div className={detailItemStyle}>
                <div className={iconContainerStyle}>
                  <svg className={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <span className={labelStyle}>Email:</span>
                  <a 
                    href={`mailto:${socio.contact_email}`} 
                    className={`${textStyle} text-[#0488AF] hover:underline`}
                  >
                    {socio.contact_email}
                  </a>
                </div>
              </div>
            )}

            {socio.landline_phone && (
              <div className={detailItemStyle}>
                <div className={iconContainerStyle}>
                  <svg className={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <span className={labelStyle}>Teléfono:</span>
                  <a 
                    href={`tel:${socio.landline_phone.replace(/[^\d+]/g, '')}`} 
                    className={`${textStyle} block text-[#0488AF] hover:underline`}
                  >
                    {socio.landline_phone}
                  </a>
                </div>
              </div>
            )}

            {socio.web_page && (
              <div className={detailItemStyle}>
                <div className={iconContainerStyle}>
                  <svg className={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </div>
                <div>
                  <span className={labelStyle}>Sitio Web:</span>
                  <a 
                    href={socio.web_page.startsWith('http') ? socio.web_page : `https://${socio.web_page}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className={`${textStyle} text-[#0488AF] hover:underline break-all`}
                  >
                    {socio.web_page.replace(/^https?:\/\//, '')}
                  </a>
                </div>
              </div>
            )}

            {socio.address && (
              <div className={detailItemStyle}>
                <div className={iconContainerStyle}>
                  <svg className={iconStyle} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <span className={labelStyle}>Dirección:</span>
                  <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(socio.address)}`} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className={`${textStyle} text-[#0488AF] hover:underline`}
                  >
                    {socio.address}
                  </a>
                </div>
              </div>
            )}
          </div>
          
          <div className="mt-6 pt-4 border-t border-gray-200 flex justify-end">
            <button 
              onClick={onClose}
              className="px-5 py-2 bg-gradient-to-r from-[#DC3465] to-[#C42251] text-white font-medium rounded-lg shadow-md hover:opacity-90 transition-all"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocioDetailModal;